import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useTranslator } from "../../context/translator";
import Datepicker from "tailwind-datepicker-react";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const ReportFilters = ({
  setCategory,
  setTemporality,
  setDateFrom,
  setDateTo,
  category,
  temporality,
  hideTerm,
  hideDate,
}) => {
  const { translate } = useTranslator();
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [companyAllow, setCompanyAllow] = useState([]);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );

  const [categoryOptions] = useState(
    IsAllow(companyAllow, "customer-02")
      ? [
          { key: "hl", name: translate("health") },
          { key: "nt", name: translate("nutrition") },
          { key: "tr", name: translate("tourism") },
          { key: "wl", name: translate("welfare") },
          { key: "tnr", name: translate("transport") },
          { key: "sh", name: translate("shop") },
          { key: "ent", name: translate("entertainment") },
          { key: "edc", name: translate("education") },
          { key: "pts", name: translate("pets") },
          { key: "all", name: translate("all") },
        ]
      : [
          { key: "gd", name: translate("good") },
          { key: "bl", name: translate("black-list") },
          { key: "cd", name: translate("cold") },
          { key: "new", name: translate("new") },
          { key: "drm", name: translate("dormant") },
          { key: "inct", name: translate("inactive") },
          { key: "ot", name: translate("other") },
          { key: "all", name: translate("all") },
        ],
  );

  const today = new Date();
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(today.getFullYear() - 1);

  const [dateOptionsFrom] = useState({
    title: "Logs Date",
    autoHide: true,
    todayBtn: true,
    clearBtn: false,
    clearBtnText: translate("clear"),

    minDate: new Date("2000-01-01"),
    theme: {
      background: "bg-gray-50 dark:bg-gray-700",
      todayBtn: "",
      clearBtn: "",
      icons: "",
      text: "text-gray-900 dark:text-white",
      disabledText: "text-slate-300",
      input: "h-14",
      inputIcon: "",
      selected: "",
    },
    icons: {
      // () => ReactElement | JSX.Element
      prev: () => <span>{translate("previous")}</span>,
      next: () => <span>{translate("next")}</span>,
    },
    datepickerClassNames: "absolute",
    defaultDate: oneYearAgo,
    language: "en",
    disabledDates: [],
    weekDays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    inputNameProp: "date",
    inputIdProp: "date",
    inputPlaceholderProp: "Select Date",
    inputDateFormatProp: {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  });

  const [dateOptionsTo] = useState({
    title: "Logs Date",
    autoHide: true,
    todayBtn: true,
    clearBtn: false,
    clearBtnText: translate("clear"),

    minDate: new Date("2000-01-01"),
    theme: {
      background: "bg-gray-50 dark:bg-gray-700",
      todayBtn: "",
      clearBtn: "",
      icons: "",
      text: "text-gray-900 dark:text-white",
      disabledText: "text-slate-300",
      input: "h-14",
      inputIcon: "",
      selected: "",
    },
    icons: {
      // () => ReactElement | JSX.Element
      prev: () => <span>{translate("previous")}</span>,
      next: () => <span>{translate("next")}</span>,
    },
    datepickerClassNames: "absolute",
    defaultDate: new Date(),
    language: "en",
    disabledDates: [],
    weekDays: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
    inputNameProp: "date",
    inputIdProp: "date",
    inputPlaceholderProp: "Select Date",
    inputDateFormatProp: {
      day: "numeric",
      month: "long",
      year: "numeric",
    },
  });

  const [temOptions] = useState([
    {
      key: "tmp",
      name: translate("temporary"),
    },
    {
      key: "prm",
      name: translate("permanent"),
    },
    {
      key: "all",
      name: translate("all"),
    },
  ]);

  const handleOnChangeCategory = (event) => {
    const value = event.target.value;

    setCategory(value);
  };

  const handleOnChangeTemporality = (event) => {
    const value = event.target.value;

    setTemporality(value);
  };

  const handleClose1 = (state) => {
    setShow1(state);
  };
  const handleClose2 = (state) => {
    setShow2(state);
  };

  const handleChangeDateFrom = (selectedDate) => {
    setDateFrom(selectedDate.toISOString());
  };
  const handleChangeDateTo = (selectedDate) => {
    setDateTo(selectedDate.toISOString());
  };

  useEffect(() => {
    if (company?.allow) {
      setCompanyAllow({ ...company.allow });
    }
  }, [company]);

  if (userLoading || companyLoading) return null;

  return (
    <>
      <div className="flex justify-between mt-6">
        {!hideDate && (
          <>
            <div className="relative">
              <label
                htmlFor="type"
                className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
              >
                {translate("dateFrom")}
              </label>
              <Datepicker
                options={dateOptionsFrom}
                onChange={handleChangeDateFrom}
                show={show1}
                setShow={handleClose1}
              />
            </div>
            <div className="relative">
              <label
                htmlFor="type"
                className="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
              >
                {translate("dateTo")}
              </label>
              <Datepicker
                options={dateOptionsTo}
                onChange={handleChangeDateTo}
                show={show2}
                setShow={handleClose2}
              />
            </div>
          </>
        )}
        <div>
          <label
            htmlFor="category"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {translate("select-category")}
          </label>
          <select
            id="category"
            name="category"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            value={category}
            onChange={handleOnChangeCategory}
            defaultValue={"gd"}
          >
            {categoryOptions?.map((option) => (
              <>
                <option key={option.key} value={option.key}>
                  {option.name}
                </option>
              </>
            ))}
          </select>
        </div>
        {!hideTerm && IsAllow(companyAllow, "customer-02") && (
          <div>
            <label
              htmlFor="temporality"
              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            >
              {translate("select-temporality")}
            </label>
            <select
              id="temporality"
              name="temporality"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              value={temporality}
              onChange={handleOnChangeTemporality}
              defaultValue={"per"}
            >
              {temOptions?.map((option) => (
                <>
                  <option key={option.key} value={option.key}>
                    {option.name}
                  </option>
                </>
              ))}
            </select>
          </div>
        )}
      </div>
    </>
  );
};

export default ReportFilters;
